import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseRemoveContractEnvelopeWitnessProps {
  id?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useRemoveContractEnvelopeWitness = ({ id, onSuccess, onError }: UseRemoveContractEnvelopeWitnessProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['removeContractEnvelopeWitness'],
    mutationFn: async (witnessId: string) => {
      const private_company_lead = {
        contract_attributes: {
          valid_envelope_attributes: {
            witnesses_attributes: [
              {
                id: witnessId,
                _destroy: true,
              },
            ],
          },
        },
      }

      await privateAxios.put(`/funnel/private_company_leads/${id}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
